module.exports = __webpack_public_path__ + "static/media/icon-resolution.65beacbc.svg";